import { CircleHelp } from "lucide-react";
import React from "react";

import { IgSwitch, IgTooltip, IgTypography } from "@intelligems/ig-theme";
import { Grid, IconButton } from "@mui/material";

import type { ConfigurationInputProps } from "../../../../../types/organization";
import { toProperCaseWithSpaces } from "../../../../../utils";

export const BooleanConfigInput = ({
  config,
  onChange,
  tooltipMessage,
  title,
}: ConfigurationInputProps) => {
  return (
    <Grid
      item
      sx={{
        "& .MuiTypography-root": {
          marginLeft: "10px",
        },
      }}
    >
      <IgSwitch
        checked={config.value}
        color="primary"
        onClick={() => {
          onChange(!config.value);
        }}
        label={
          <Grid container spacing={0.5}>
            <Grid item>
              <IgTypography>
                {title || toProperCaseWithSpaces(config.key)}
              </IgTypography>
            </Grid>
            {tooltipMessage && (
              <Grid item>
                <IgTooltip title={tooltipMessage}>
                  <IconButton size={"small"} aria-label="info">
                    <CircleHelp size={16} />
                  </IconButton>
                </IgTooltip>
              </Grid>
            )}
          </Grid>
        }
      />
    </Grid>
  );
};
